import { render, staticRenderFns } from "./AlphaReg.vue?vue&type=template&id=bb6306ae&scoped=true"
import script from "./AlphaReg.vue?vue&type=script&lang=js"
export * from "./AlphaReg.vue?vue&type=script&lang=js"
import style0 from "./AlphaReg.vue?vue&type=style&index=0&id=bb6306ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6306ae",
  null
  
)

export default component.exports